import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { requireUser } from '../authz/access.js';
import { Student } from '../student.js';
import { Teacher } from '../teacher.js';

/** Saves the caller's own "E-Mail Benachrichtigungen" setting on whichever profile they have. */
export const setEmailNotificationsMutation = registerMutation({
  operationName: 'setEmailNotificationsMutation',
  type: () => Boolean,
  params: [{ name: 'enabled', type: () => Boolean }],
  resolve: (enabled: boolean) => async () => {
    const { userID } = await requireUser();
    let matched = 0;
    // One profile per account; updating both by userID touches exactly the one that exists.
    for (const Profile of [Teacher, Student]) {
      const result = await (
        await getRawCollection(Profile._collectionName)
      ).updateOne({ userID }, { $set: { emailNotifications: enabled === true } });
      matched += result.matchedCount;
    }
    return matched > 0;
  },
});
